// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__mx3Sn","footer":"ModalUpdate_footer__6NGV4"};